import React, { useState, useEffect, Fragment } from "react";
import ProfileBar from "./components/ProfileBar";
import PageTitle from "./components/PageTitle";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";

import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Icon,
  IconButton,
  InputAdornment,
  LinearProgress,
  Stack,
  TextField,
} from "@mui/material";
import moment from "moment";
import dayjs from "dayjs";

import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { fetchData, currentFormat } from "./js/main";
import PageBar from "./components/PageBar";
import { useNavigate } from "react-router-dom";
import { conf } from "./const";

const limit = 50;
const styles = {
  td: { fontSize: ".7rem", lineHeight: "15px", padding: "7px 3px" },
  bill_btn: { fontSize: ".7rem", lineHeight: "15px", padding: "3px 3px" },
};

function generateOptions(filter) {
  return new Promise(async (resolve) => {
    var toDate = new Date(filter.toDate);
    toDate.setDate(toDate.getDate() + 1);
    let Limit = limit;
    if (filter.limit) Limit = filter.limit;
    let match = {};
    let options = {
      sort: { bill_id: 1 },
      limit: Limit,
      skip: filter.skip,
      facet: true,
    };
    if (filter.keyword.trim() !== "") {
      match = {
        value: filter.keyword.trim(),
        fields: [
          "bill_id",
          "payer.name",
          "replace_bill_no",
          "canceled.new_bill_no",
          "operator.usn",
        ],
      };
      options.keyword = match;
    } else {
      match = {
        $and: [
          {
            transactionDateandTime: {
              $gte: moment(filter.fromDate).format("YYYY-MM-DD"),
            },
          },
          {
            transactionDateandTime: {
              $lt: moment(toDate).format("YYYY-MM-DD"),
            },
          },
        ],
      };
      if (filter.operators && filter.operators.length > 0) {
        let matchOperators = { $or: [] };
        if (filter.operators.indexOf("ALL") < 0) {
          for (let operator of filter.operators) {
            matchOperators["$or"].push({
              $or: [
                { "operator.usn": operator },
                { "operator.usn": operator + "@cmu.ac.th" },
              ],
            });
          }
          match["$and"].push(matchOperators);
        }
      } else match["$and"].push({ "operator.usn": "" });

      if (filter.cash === true || filter.tranfer === true) {
        let matchPay = { $or: [] };
        if (filter.cash === true) {
          matchPay["$or"].push({ transactionType: "Pay by Cash" });
        }
        if (filter.tranfer === true) {
          // matchPay["$or"].push({
          //   $or: [
          //     { transactionType: "Domestic Transfers" },
          //     { transactionType: "Pay by Transfer" },
          //   ],
          // });
          matchPay["$or"].push({ transactionType: "Domestic Transfers" });
        }
        match["$and"].push(matchPay);
      } else match["$and"].push({ transactionType: "" });

      options.match = match;
    }
    resolve(options);
  });
}

export default function RptBill(props) {
  const [operators, setOperators] = useState();
  const [pageNo, setPageNo] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [filter, setFilter] = useState();
  const [bills, setBills] = useState();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      let toDate = new Date();
      let fromDate = conf.onDev === true ? "2025-04-21" : new Date();
      // let fromDate = "2022-01-01";
      let operators = await fetchData("post", "/v3/bill/operator", {
        from_date: fromDate,
        to_date: toDate,
      });
      setOperators(operators);
      setFilter({
        //   fromDate: new Date(),
        profile: props.profile,
        skip: 0,
        fromDate,
        toDate,
        keyword: "",
        cash: true,
        tranfer: true,
        operators: [props.profile.usn],
      });
    })();
  }, [props]);

  useEffect(() => {
    (async () => {
      if (filter) {
        setLoading(true);
        /*
        var toDate = new Date(filter.toDate);
        toDate.setDate(toDate.getDate() + 1);
        let match = {};
        let options = {
          sort: { bill_id: 1 },
          limit,
          skip: filter.skip,
          facet: true,
        };
        if (filter.keyword.trim() !== "") {
          match = {
            value: filter.keyword.trim(),
            fields: [
              "bill_id",
              "payer.name",
              "replace_bill_no",
              "canceled.new_bill_no",
              "operator.usn",
            ],
          };
          options.keyword = match;
        } else {
          match = {
            $and: [
              {
                transactionDateandTime: {
                  $gte: moment(filter.fromDate).format("YYYY-MM-DD"),
                },
              },
              {
                transactionDateandTime: {
                  $lt: moment(toDate).format("YYYY-MM-DD"),
                },
              },
            ],
          };
          if (filter.operators && filter.operators.length > 0) {
            let matchOperators = { $or: [] };
            if (filter.operators.indexOf("ALL") < 0) {
              for (let operator of filter.operators) {
                matchOperators["$or"].push({
                  $or: [
                    { "operator.usn": operator },
                    { "operator.usn": operator + "@cmu.ac.th" },
                  ],
                });
              }
              match["$and"].push(matchOperators);
            }
          } else match["$and"].push({ "operator.usn": "" });

          if (filter.cash === true || filter.tranfer === true) {
            let matchPay = { $or: [] };
            if (filter.cash === true) {
              matchPay["$or"].push({ transactionType: "Pay by Cash" });
            }
            if (filter.tranfer === true) {
              matchPay["$or"].push({
                $or: [
                  { transactionType: "Domestic Transfers" },
                  { transactionType: "Pay by Transfer" },
                ],
              });
            }
            match["$and"].push(matchPay);
          } else match["$and"].push({ transactionType: "" });

          options.match = match;
        }
        */
        const options = await generateOptions(filter);
        console.log(options);
        let Bills = await fetchData("post", "/v3/bill/report", options);
        setBills(Bills);
        setLoading(false);
      }
    })();
  }, [filter]);

  useEffect(() => {
    if (bills) {
      let count = Math.ceil(bills.count / limit);
      if (count < 1) count = 1;
      setPageCount(count);
    }
  }, [bills]);

  function changeFilter(field, value) {
    setFilter({ ...filter, [field]: value, skip: 0 });
    setPageNo(1);
    // setPageState({ ...pageState, currentPage: 1 });
  }

  function changePage(no) {
    let skip = (no - 1) * limit;
    setFilter({ ...filter, skip });
    setPageNo(no);
  }

  async function updateFacet(bill) {
    // update billers
    let Bills = JSON.parse(JSON.stringify(bills));
    let { details } = bill.invoice_id;
    let facet = JSON.parse(JSON.stringify(Bills.facet.billers));
    for (let item of details) {
      let key = facet.findIndex((j) => j.account_code === item.account_code);
      facet[key].canceled_amount += item.amount;
      facet[key].canceled_count++;
    }
    Bills.facet.billers = facet;

    // update operator
    facet = JSON.parse(JSON.stringify(Bills.facet.operators));
    let key = facet.findIndex((j) => j.label === bill.operator.usn);
    facet[key].canceledAmount += parseFloat(bill.amount);
    facet[key].canceledCount++;
    Bills.facet.operators = facet;

    // update payType
    facet = JSON.parse(JSON.stringify(Bills.facet.payType));
    key = facet.findIndex((j) => j.label === bill.transactionType);
    facet[key].canceledAmount += parseFloat(bill.amount);
    facet[key].canceledCount++;
    Bills.facet.payType = facet;

    Bills.facet.canceledAmount += parseFloat(bill.amount);
    Bills.facet.canceledCount++;
    key = Bills.result.findIndex((j) => j._id === bill._id);
    Bills.result[key] = bill;
    setBills(Bills);
  }

  async function updatedBill(bill_id) {
    const updatedBill = await fetchData("get", "/v3/bill/" + bill_id);
    updateFacet(updatedBill);
  }

  async function exportExcel() {
    let sheet1 = [];
    let Filter = JSON.parse(JSON.stringify(filter));
    Filter.skip = 0;
    Filter.limit = 10000;
    const options = await generateOptions(Filter);
    let Bills = await fetchData("post", "/v3/bill/report", options);

    for (const bill of Bills.result) {
      let biller_name = "";
      for (const detail of bill.invoice_id.details)
        biller_name += detail.biller_name + ",";
      let row = {
        invoice_date: moment(bill.invoice_id.update_time).format("DD MMM YYYY"),
        invoice_id: bill.invoice_id.invoice_id,
        bill_date: moment(bill.transactionDateandTime).format("DD MMM YYYY"),
        bill_id: bill.bill_id,
        payer_name: bill.payer && bill.payer.name ? bill.payer.name : "-",
        amount: parseFloat(bill.amount).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        biller_name,
        pay_by: bill.transactionType,
        ref2: bill.billPaymentRef2 || "",
        operator_name: bill.operator ? bill.operator.name : "",
        remark: bill.invoice_id.remark || "",
        cancel_remark: bill.canceled.remark || "",
        cancel_by: bill.canceled.usn || "",
        new_bill: bill.canceled.new_bill_no || "",
        replace_bill: bill.replace_id ? bill.replace_id.bill_id : "",
      };
      sheet1.push(row);
    }
    let dataSet = [
      {
        name: "Bills",
        columns: [
          { label: "Invoice Date", value: "invoice_date" },
          { label: "Invoice No", value: "invoice_id" },
          { label: "Receive Date", value: "bill_date" },
          { label: "Bill No", value: "bill_id" },
          { label: "Payer Name", value: "payer_name" },
          { label: "Amount", value: "amount" },
          { label: "Biller Name", value: "biller_name" },
          { label: "Pay By", value: "pay_by" },
          { label: "Ref2", value: "ref2" },
          { label: "Operator", value: "operator_name" },
          { label: "Remark", value: "remark" },
          { label: "Cancel Remark", value: "cancel_remark" },
          { label: "Cancel By", value: "cancel_by" },
          { label: "New Bill", value: "new_bill" },
          { label: "Replace Bill", value: "replace_bill" },
        ],
        sheet: sheet1,
      },
      /*
      { name: "Billers", columns: [], sheet: [] },
      { name: "Operators", columns: [], sheet: [] },
      { name: "Pay Types", columns: [], sheet: [] },
      */
    ];
    let cookie = JSON.parse(localStorage.getItem(conf.cookieName));
    cookie.excel = dataSet;
    localStorage.setItem(conf.cookieName, JSON.stringify(cookie));
    document.getElementById("printFrame").src =
      process.env.PUBLIC_URL + "/excel";
  }
  return (
    <div className="content">
      <ProfileBar profile={props.profile} />
      <PageTitle page={props.page} />
      {filter && bills && (
        <FilterForm
          filter={filter}
          onChangeFilter={changeFilter}
          operators={operators}
          count={bills.count || 0}
        />
      )}
      {loading ? (
        <div style={{ paddingTop: "30px" }}>
          <LinearProgress />
        </div>
      ) : (
        <>
          {bills && (
            <>
              <PageBar
                onChangePage={changePage}
                count={pageCount}
                pageNo={pageNo}
              />
              <BillTable bills={bills} onUpdatedBill={updatedBill} />
              <FacetArea facet={bills.facet} billCount={bills.count} />
              <div style={{ textAlign: "right", paddingTop: "20px" }}>
                <Button
                  variant="contained"
                  startIcon={<Icon>download</Icon>}
                  onClick={exportExcel}
                >
                  Download
                </Button>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}

function FacetArea(props) {
  const [facet, setFacet] = useState();
  useEffect(() => {
    if (props) {
      setFacet(props.facet);
    }
  }, [props]);

  return (
    <div>
      {facet && (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TableContainer component={Paper} sx={{ marginTop: "15px" }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell colSpan={8}>Billers</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ maxWidth: "60px" }}>No</TableCell>
                    <TableCell sx={{ maxWidth: "100px" }}>Chart Code</TableCell>
                    <TableCell sx={{ maxWidth: "100px" }}>
                      Account Code
                    </TableCell>
                    <TableCell>Biller Name</TableCell>
                    <TableCell sx={{ maxWidth: "100px" }}>Bill Count</TableCell>
                    <TableCell sx={{ maxWidth: "80px" }}>Income</TableCell>
                    <TableCell sx={{ maxWidth: "80px" }}>Cancel</TableCell>
                    <TableCell sx={{ maxWidth: "80px" }}>Amount</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {facet.billers.length === 0 && (
                    <TableRow>
                      <TableCell
                        colSpan={8}
                        align="center"
                        sx={{ lineHeight: "70px", color: "#999" }}
                      >
                        No information found
                      </TableCell>
                    </TableRow>
                  )}
                  {facet.billers.map((biller, key) => (
                    <TableRow key={key} hover>
                      <TableCell align="center">{key + 1}</TableCell>
                      <TableCell align="center">{biller.chart_code}</TableCell>
                      <TableCell align="center">
                        {biller.account_code}
                      </TableCell>
                      <TableCell>{biller.biller_name}</TableCell>
                      <TableCell align="center">
                        {currentFormat(biller.bill_count, true)}
                      </TableCell>
                      <TableCell align="right">
                        {currentFormat(biller.amount)}
                      </TableCell>
                      <TableCell align="right">
                        {currentFormat(biller.canceled_amount)}
                      </TableCell>
                      <TableCell align="right">
                        {currentFormat(biller.amount - biller.canceled_amount)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={12} lg={6}>
            <TableContainer component={Paper} sx={{ marginTop: "15px" }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell colSpan={6}>Operators</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ maxWidth: "60px" }}>No</TableCell>
                    <TableCell>Account</TableCell>
                    <TableCell sx={{ maxWidth: "100px" }}>Bill Count</TableCell>
                    <TableCell sx={{ maxWidth: "80px" }}>Income</TableCell>
                    <TableCell sx={{ maxWidth: "80px" }}>Cancel</TableCell>
                    <TableCell sx={{ maxWidth: "80px" }}>Amount</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {facet.operators.length === 0 && (
                    <TableRow>
                      <TableCell
                        colSpan={6}
                        align="center"
                        sx={{ lineHeight: "70px", color: "#999" }}
                      >
                        No information found
                      </TableCell>
                    </TableRow>
                  )}
                  {facet.operators.map((operator, key) => (
                    <TableRow key={key}>
                      <TableCell align="center">{key + 1}</TableCell>
                      <TableCell>{operator.label}</TableCell>
                      <TableCell align="center">
                        {currentFormat(operator.billCount, true)}
                      </TableCell>
                      <TableCell align="right">
                        {currentFormat(operator.amount)}
                      </TableCell>
                      <TableCell align="right">
                        {currentFormat(operator.canceledAmount)}
                      </TableCell>
                      <TableCell align="right">
                        {currentFormat(
                          operator.amount - operator.canceledAmount,
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={12} lg={6}>
            <TableContainer component={Paper} sx={{ marginTop: "15px" }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell colSpan={6}>Pay Types</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ maxWidth: "60px" }}>No</TableCell>
                    <TableCell>Type Name</TableCell>
                    <TableCell sx={{ maxWidth: "100px" }}>Bill Count</TableCell>
                    <TableCell sx={{ maxWidth: "80px" }}>Income</TableCell>
                    <TableCell sx={{ maxWidth: "80px" }}>Cancel</TableCell>
                    <TableCell sx={{ maxWidth: "80px" }}>Amount</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {facet.payType.map((type, key) => (
                    <TableRow key={key}>
                      <TableCell align="center">{key + 1}</TableCell>
                      <TableCell>{type.label}</TableCell>
                      <TableCell align="center">
                        {currentFormat(type.billCount, true)}
                      </TableCell>
                      <TableCell align="right">
                        {currentFormat(type.amount)}
                      </TableCell>
                      <TableCell align="right">
                        {currentFormat(type.canceledAmount)}
                      </TableCell>
                      <TableCell align="right">
                        {currentFormat(type.amount - type.canceledAmount)}
                      </TableCell>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell colSpan={2} align="center" className="bold">
                      Total
                    </TableCell>
                    <TableCell align="center" className="bold">
                      {currentFormat(props.billCount, true)}
                    </TableCell>
                    <TableCell align="right" className="bold">
                      {currentFormat(facet.amount)}
                    </TableCell>
                    <TableCell align="right" className="bold">
                      {currentFormat(facet.canceledAmount)}
                    </TableCell>
                    <TableCell align="right" className="bold">
                      {currentFormat(facet.amount - facet.canceledAmount)}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      )}
    </div>
  );
}

function BillTable(props) {
  const navigate = useNavigate();
  const [bills, setBills] = useState();
  const [cancelDialogState, setCancelDialogState] = useState({ open: false });
  const titles = [
    "Invoice Date",
    "Invoice No",
    "Receive Date",
    "Bill No",
    "Payer Name",
    "Amount",
    "Biller Name",
    "Pay By",
    // "Transaction",
    "Ref2",
    "Operator",
    "Remark",
    "Cancel",
    "New Bill",
    "Replace Bill",
  ];

  useEffect(() => {
    if (props && props.bills) {
      setBills(props.bills);
    }
  }, [props]);

  async function cancelBill(form) {
    const result = await fetchData(
      "put",
      "/v3/bill/" + form.bill_id + "/cancel",
      form,
    );
    if (result && result._id) {
      props.onUpdatedBill(result._id);
      setCancelDialogState({ open: false });
    }
  }

  return (
    <div>
      {bills && (
        <>
          <CancelBillDialog
            state={cancelDialogState}
            onChangeState={(state) =>
              setCancelDialogState({ ...cancelDialogState, ...state })
            }
            onCancel={cancelBill}
          />
          <TableContainer component={Paper} sx={{ marginTop: "15px" }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {titles.map((title, key) => (
                    <TableCell key={key} sx={styles.td}>
                      {title}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {bills.count === 0 && (
                  <TableRow>
                    <TableCell
                      colSpan={14}
                      sx={{ lineHeight: "70px", color: "#999" }}
                      align="center"
                    >
                      Not Found Result
                    </TableCell>
                  </TableRow>
                )}
                {bills.result.map((bill, key) => (
                  <TableRow key={key} hover>
                    <TableCell sx={styles.td} align="center">
                      {moment(
                        bill.invoice_id.update_time ||
                          bill.invoice_id.create_date,
                      ).format("DD MMM YYYY")}
                    </TableCell>
                    <TableCell sx={styles.td} align="center">
                      {bill.invoice_id.invoice_id}
                    </TableCell>
                    <TableCell sx={styles.td} align="center">
                      {moment(bill.transactionDateandTime).format(
                        "DD MMM YYYY",
                      )}
                    </TableCell>
                    <TableCell
                      sx={styles.td}
                      className="noPadding"
                      align="center"
                    >
                      <Button
                        onClick={() =>
                          window.open(
                            process.env.PUBLIC_URL + "/bill/" + bill.bill_id,
                          )
                        }
                        sx={styles.bill_btn}
                      >
                        {bill.bill_id}
                      </Button>
                    </TableCell>
                    <TableCell sx={styles.td}>
                      {bill.payer && bill.payer.name ? (
                        bill.payer.name
                      ) : (
                        <div style={{ textAlign: "center" }}>-</div>
                      )}
                    </TableCell>
                    <TableCell sx={styles.td} align="center">
                      {parseFloat(bill.amount).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </TableCell>
                    <TableCell sx={styles.td}>
                      {bill.invoice_id.details.map((item, key) => (
                        <div key={key}>{item.biller_name}</div>
                      ))}
                    </TableCell>
                    <TableCell sx={styles.td} align="center">
                      {bill.transactionType}
                    </TableCell>
                    <TableCell sx={styles.td} align="center">
                      {bill.billPaymentRef2}
                    </TableCell>
                    <TableCell sx={styles.td} align="center">
                      {bill.operator && (
                        <>
                          {bill.operator.name &&
                          bill.operator.name.indexOf("undefined") < 0 ? (
                            <>{bill.operator.name}</>
                          ) : (
                            <>{bill.operator.usn}</>
                          )}
                        </>
                      )}
                      {/* {bill.operator && bill.operator.name} */}
                    </TableCell>
                    <TableCell sx={styles.td} align="center">
                      {bill.invoice_id.remark}
                    </TableCell>
                    {bill.canceled.remark ? (
                      <TableCell
                        sx={styles.td}
                        align="center"
                        className="inputPadding"
                      >
                        {bill.canceled.remark}
                        <div style={{ color: "#00f" }}>{bill.canceled.usn}</div>
                      </TableCell>
                    ) : (
                      <TableCell sx={{ padding: "2px 2px" }} align="center">
                        <IconButton
                          sx={{ padding: "0px 0px" }}
                          color="error"
                          onClick={() =>
                            setCancelDialogState({
                              ...cancelDialogState,
                              open: true,
                              bill: bill,
                            })
                          }
                        >
                          <Icon>highlight_off</Icon>
                        </IconButton>
                      </TableCell>
                    )}
                    <TableCell className="noPadding" align="center">
                      {bill.canceled.status === true && (
                        <>
                          {bill.canceled &&
                          bill.canceled.new_bill &&
                          bill.canceled.new_bill.bill_id ? (
                            <Button
                              onClick={() =>
                                window.open(
                                  process.env.PUBLIC_URL +
                                    "/bill/" +
                                    bill.canceled.new_bill_no,
                                )
                              }
                              sx={styles.bill_btn}
                            >
                              {bill.canceled.new_bill_no}
                            </Button>
                          ) : (
                            <IconButton
                              sx={{ padding: "0px 0px" }}
                              color="success"
                              onClick={() =>
                                navigate(
                                  process.env.PUBLIC_URL +
                                    "/bill/replace/" +
                                    bill.bill_id,
                                )
                              }
                            >
                              <Icon>add_circle_outline</Icon>
                            </IconButton>
                          )}
                        </>
                      )}
                    </TableCell>
                    <TableCell className="noPadding" align="center">
                      {bill.replace_id && bill.replace_id.bill_id && (
                        <Button
                          onClick={() =>
                            window.open(
                              process.env.PUBLIC_URL +
                                "/bill/" +
                                bill.replace_id.bill_id,
                            )
                          }
                          sx={styles.bill_btn}
                        >
                          {bill.replace_id.bill_id}
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
    </div>
  );
}

function FilterForm({ filter, operators, onChangeFilter, count }) {
  function selectOperators(e) {
    let usn = e.target.value;
    let i = usn.indexOf("ALL");
    if (i > -1) {
      usn = ["ALL"];
      for (let o of operators) usn.push(o.usn);
    }
    onChangeFilter("operators", usn);
  }
  return (
    <Grid container sx={{ paddingTop: "10px" }} spacing={2}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Grid item xs={6} lg={3}>
          <DatePicker
            format="DD MMM YYYY"
            label="Form Date"
            value={dayjs(filter.fromDate)}
            onChange={(newValue) =>
              onChangeFilter("fromDate", new Date(newValue))
            }
            slotProps={{
              textField: {
                InputLabelProps: { shrink: true },
                fullWidth: true,
                size: "small",
              },
            }}
          />
        </Grid>
        <Grid item xs={6} lg={3}>
          <DatePicker
            format="DD MMM YYYY"
            onChange={(newValue) =>
              onChangeFilter("toDate", new Date(newValue))
            }
            label="To Date"
            value={dayjs(filter.toDate)}
            slotProps={{
              textField: {
                InputLabelProps: { shrink: true },
                fullWidth: true,
                size: "small",
              },
            }}
          />
        </Grid>
        <Grid item xs={6} lg={3}>
          <FormControl fullWidth>
            <InputLabel id="demo-multiple-checkbox-label" shrink>
              Operator
            </InputLabel>
            <Select
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              label="Operator"
              value={filter.operators}
              multiple
              onChange={selectOperators}
              input={<OutlinedInput label="Operator" size="small" />}
              renderValue={(selected) => selected.join(", ")}
            >
              <MenuItem value="ALL">
                <Checkbox checked={filter.operators.indexOf("ALL") > -1} />
                <ListItemText primary="ALL" />
              </MenuItem>
              {operators
                .filter((j) => j.usn !== null)
                .map((name, key) => (
                  <MenuItem key={key} value={name.usn}>
                    <Checkbox
                      checked={filter.operators.indexOf(name.usn) > -1}
                    />
                    <ListItemText primary={name.usn} />
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          <div style={{ textAlign: "right" }}>
            <Button
              style={{
                padding: "0px 0px",
                fontSize: ".6rem",
              }}
              onClick={() => onChangeFilter("operators", [])}
            >
              Clear
            </Button>
          </div>
        </Grid>
        <Grid item xs={6} lg={3}>
          <TextField
            fullWidth
            InputLabelProps={{ shrink: true }}
            label="Keyword"
            placeholder="ค้นหา..."
            size="small"
            id="keyword"
            // value={filter.keyword}
            onKeyUp={(e) =>
              e.key === "Enter" && onChangeFilter("keyword", e.target.value)
            }
            InputProps={{
              sx: { paddingRight: "0px" },
              endAdornment: (
                <InputAdornment position="start">
                  <Icon>search</Icon>
                </InputAdornment>
              ),
            }}
          />
          <div style={{ textAlign: "right" }}>
            <Button
              style={{
                padding: "0px 0px",
                fontSize: ".6rem",
              }}
              onClick={() => {
                onChangeFilter("keyword", "");
                document.getElementById("keyword").value = "";
              }}
            >
              Clear
            </Button>
          </div>
        </Grid>
        <Grid xs={6} item className="bold">
          Result : {count} bill(s)
        </Grid>
        <Grid xs={6} item align="right">
          <Stack direction="row" sx={{ width: "190px" }}>
            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={filter.cash}
                    onChange={() => onChangeFilter("cash", !filter.cash)}
                  />
                }
                label={<div>CASH</div>}
              />
            </div>
            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={filter.tranfer}
                    onChange={() => onChangeFilter("tranfer", !filter.tranfer)}
                  />
                }
                label={<div>TRANFER</div>}
              />
            </div>
          </Stack>
        </Grid>
      </LocalizationProvider>
    </Grid>
  );
}

function CancelBillDialog({ state, onChangeState, onCancel }) {
  const [form, setForm] = useState();
  const [disabled, setDisabled] = useState(true);
  const choices = [
    { value: "1", label: "ชื่อผิด" },
    { value: "2", label: "จำนวนเงินผิด" },
    { value: "3", label: "ประเภทรายได้ผิด" },
    { value: "4", label: "เปลี่ยนใจไม่ชำระเงิน" },
    { value: "5", label: "อื่น ๆ", other: true },
  ];
  useEffect(() => {
    if (state && state.open === true && state.bill) {
      setForm({ bill_id: state.bill._id });
    } else setForm(null);
  }, [state]);

  function save() {
    if (form.value) {
      setDisabled(true);
      let key = choices.findIndex((j) => j.value === form.value);
      if (key > -1) {
        let remark = choices[key].label;
        if (choices[key].other === true && form.other && form.other !== "") {
          remark += ` (${form.other})`;
        }
        onCancel({ remark, bill_id: form.bill_id });
      }
      setDisabled(false);
    }
  }
  return (
    <React.Fragment>
      {form && state.open === true && (
        <Dialog open={state.open}>
          <DialogTitle id="alert-dialog-title">
            {"เหตุผลการยกเลิกใบเสร็จ"}
          </DialogTitle>
          <DialogContent>
            <div style={{ fontSize: ".9rem" }}>
              ยกเลิกใบเสร็จเลขที่{" "}
              <span style={{ color: "#f00" }}>{state.bill.bill_id}</span>
            </div>
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                sx={{ paddingTop: "10px" }}
                onChange={(e) => {
                  setDisabled(false);
                  setForm({ ...form, value: e.target.value });
                }}
              >
                {choices.map((ch, key) => (
                  <Stack key={key} direction={"row"}>
                    <FormControlLabel
                      value={ch.value}
                      sx={{ marginRight: "10px" }}
                      size="small"
                      control={<Radio sx={{ padding: "5px 5px" }} />}
                      label={
                        <div style={{ fontSize: ".9rem" }}>{ch.label}</div>
                      }
                    />
                    {ch.other && (
                      <TextField
                        size="small"
                        sx={{ minWidth: "250px" }}
                        value={form.other || ""}
                        onChange={(e) =>
                          setForm({ ...form, other: e.target.value })
                        }
                      />
                    )}
                  </Stack>
                ))}
              </RadioGroup>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => onChangeState({ open: false })}>
              Cancel
            </Button>
            <Button onClick={save} disabled={disabled}>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </React.Fragment>
  );
}
